export default "__VITE_ASSET__8Rz$O4_P__"